import { render } from "./StrutureSymabio.vue?vue&type=template&id=080062d6"
import script from "./StrutureSymabio.vue?vue&type=script&lang=js"
export * from "./StrutureSymabio.vue?vue&type=script&lang=js"

import "./StrutureSymabio.vue?vue&type=style&index=0&id=080062d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__